export const parseFileString = (url) => {
    let file = url.split('?')[0].split('/');
    file = file[file.length - 1].split('.');
    const extension = file[file.length - 1];
    return extension;
};
